import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        ruleDelete: builder.mutation({
            query: (ruleId: string) => ({
                url: `/rule/rule/` + ruleId,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const { useRuleDeleteMutation } = importTradeDataApiSlice;
